import { ResultType, VirtualChallengeType } from '@fastnorth/timer-api';

type GetVirtualChallengePrimaryStatLabelKeyProps = {
  resultsType?: ResultType | null;
  challengeType?: VirtualChallengeType | string | null;
};

const getVirtualChallengePrimaryStatLabelKey = ({
  resultsType,
  challengeType,
}: GetVirtualChallengePrimaryStatLabelKeyProps): string => {
  if (resultsType === ResultType.VIRTUAL) {
    return 'default.time_of';
  }

  if (resultsType !== ResultType.VIRTUAL_CHALLENGE) {
    return 'default.official_time_of';
  }

  if (challengeType == null) {
    return 'default.time_of';
  }

  switch (challengeType) {
    case VirtualChallengeType.DISTANCE:
      return 'default.distance_of';
    case VirtualChallengeType.ELEVATION:
      return 'default.elevation_of';
    case VirtualChallengeType.TALLY:
      return 'default.tally_of';
    case VirtualChallengeType.TIME:
    default:
      return 'default.time_of';
  }
};

export default getVirtualChallengePrimaryStatLabelKey;
